// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"6e3bd27a","433":"e96a9ee8","775":"e2a99ef3"}[chunkId] + ".chunk.js";
};